import React from "react";
import Grid from "@material-ui/core/Grid";
import { CSSTransition} from 'react-transition-group';
import {withRouter } from "react-router-dom";
import backgroundImage from "../../assets/images/main_background.png";
import mobile from "../../assets/images/mobile.png";
import '../../App.scss';
import goldCoin from "../../assets/images/ic_coin.png";
import WoodenInput from "../pageComponents/Settings/Free/WoodenInput";
import CardNumber from "../../assets/images/ic_cardnumber.png";
import Button from "../pageComponents/Settings/Free/Button";
import axios from "axios";
import {freeGiftRedeem, usersLogin, usersValidate} from "../../Utility/Url";
import PicoLoader from "../pageComponents/Common/PicoLoader";
import Axios from "../../Plugins/Axios";

class Login extends React.Component {
    constructor(props) {
        super(props)
        this.inputRef = React.createRef()
        this.state={
            trueState:true,
            appHasLoaded:false,
            showDialog:false,
            inputReset:false,
            picoSmallLoader:false,
            loginStep:1,
            phoneText:'شماره تلفن همراه خود را برای کد فعال سازی وارد کنید',
            placeholder:'شماره همراه وارد کنید',
            value:'',
            style: {
                completed:5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize:'100% 100%',
                    backgroundRepeat: 'no-repeat',
                    width:'100%',
                    backgroundColor:"#343168",
                    backgroundBlendMode:'soft-light',
                    phoneNumber:null,
                    flex:1,
                    minHeight:'0',
                },
            }
        }
    }
    handleInput=(data)=>{
    }
    sendCode=async (code)=>{
        await axios.post(usersLogin,{
            mobile:code
        })
            .then(res => {
                this.setState({
                    phoneText:`لطفا کد ارسال شده به شماره ${code} را وارد کنید`,
                    phoneNumber:code,
                    placeholder:'کد تایید',
                    loginStep:2,
                    value:'0',
                    inputReset:true,
                },()=>{
                    this.setState({
                        inputReset:false,
                    })
                })
                const {data}=res
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    login=async (data)=>{
        await axios.post(usersValidate,{
            mobile:data.mobile,
            code:data.code
        })
            .then(res => {
                const Ax=new Axios()
                const {data}=res
                Ax.setAuth(data.token)
                this.props.history.push('/home')
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    handleClick=async ()=>{
        const {loginStep}=this.state
        const code=this.inputRef.current.state.input
        this.setState({
            picoSmallLoader:true
        })
        if (loginStep===1){
            await this.sendCode(code)
        }else if (loginStep===2){
            const {phoneNumber}=this.state
           const data={
               mobile:phoneNumber,
               code:code
           }
           await this.login(data)
        }
        this.setState({
            picoSmallLoader:false
        })

    }
    componentDidMount() {
        this.props.toggleBottomNavbar()
    }

    render() {
        const handleClose=(()=>{
            this.setState({
                showDialog:false
            })
        })
        const{placeholder,value,inputReset}=this.state
        const woodenInput={
            backgroundColor:'transparent',
            layerRadius:'15px',
            inputTextSize:'15px',
            inputMaxLength:'11',
            holderImage:CardNumber,
            color:'#ffffff',
            value:value,
            placeHolder:placeholder,
            reset:inputReset,
            onlyInt:true
        }
        const button={
            text:'ورود',
            backgroundColor:'purple',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderRadius:'5px',
        }
        const {trueState,phoneText,loginStep,picoSmallLoader}=this.state
        return(
            <Grid direction={"column"} item container justify={"center"} style={this.state.style.root}
                className='login'
            >
                <Grid item sm={12} xs={12} direction={"column"} justify={'center'} container
                      style={{flex:'1',minHeight:'0'}}
                >
                    <Grid item container xs={12} justify={"space-around"} alignItems={"center"} sm={12} className='scrollBar'
                          style={{flex:'1',minHeight:'0',overflow:'auto'}} direction={"column"}>
                        <Grid sm={3} xs={3} container alignItems={"center"} justify={"center"}>
                            <img src={mobile} alt=""/>
                        </Grid>
                        <Grid container direction={"column"} alignItems={"center"} justify={"center"}>
                            <Grid>
                                <p className='login-phone-text'>
                                    {phoneText}
                                </p>
                            </Grid>

                            {
                                loginStep===1&&
                                <Grid container direction={"column"} alignItems={"center"} justify={"center"}>

                                    <Grid direction={"row"} container alignItems={"center"} justify={"center"}
                                    className='login-prize-text' sm={9} xs={9}
                                >
                                    <Grid sm={5} xs={5} container alignItems={"center"} justify={"center"}>
                                        <p>جایزه برای ثبت نام شما</p>
                                    </Grid>
                                    <Grid sm={1} xs={1} style={{position:'relative'}} container alignItems={"center"} justify={"center"}>
                                        <img src={goldCoin} alt=""/>
                                        <p style={{position:'absolute',color:'#000000'}}>
                                            1
                                        </p>
                                    </Grid>
                                </Grid>
                                </Grid>
                            }
                        </Grid>
                        <Grid  container alignItems={"center"} justify={"center"}>
                            <Grid container sm={6} xs={6}>
                                <WoodenInput input={this.handleInput} data={woodenInput}  ref={this.inputRef}/>
                            </Grid>
                        </Grid>
                         <Grid container justify={"center"} alignItems={"center"} >
                             {
                                 !picoSmallLoader &&
                                 <Grid onClick={this.handleClick} className='clickable' container
                                       style={{height: '80px'}} sm={6} xs={6}>
                                     <Button data={button}/>
                                 </Grid>
                             }
                             {
                                 picoSmallLoader &&
                                 <Grid sm={6} xs={6} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                       style={{position:'relative',height:'50px'}}
                                 >
                                     <Grid sm={2} xs={2} item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                         <PicoLoader/>
                                     </Grid>
                                 </Grid>
                             }
                         </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default withRouter (Login)